/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { B400 } from '@atlaskit/theme/colors';
const styles = css({
  color: `var(--ds-link, ${B400})`,
  wordBreak: 'break-all'
});
export const Link = ({
  url,
  testId = 'block-card',
  className
}) => {
  return jsx("span", {
    "data-testid": `${testId}-link`
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className,
    css: styles
  }, url);
};